// NB! When adding new specialFeatures it's important to make sure that varnish cache
// between different applications wont cause vue hydration errors

export default {
  main_portal_url: 'https://www.delfi.lt',
  main_slug: 'news',
  old_type_redirects: true,
  social_share: {
    facebook: 'https://www.facebook.com/sharer/sharer.php',
    linkedin: 'https://www.linkedin.com/shareArticle',
    messenger: 'https://www.facebook.com/dialog/send',
    twitter: 'https://twitter.com/share',
  },
  player_url: 'https://tasku.delfi.ee/kuula',
  s2f_url: 'https://www.delfi.lt/s2f.php',
  disableComments: false,
  disableLogin: false,
  applications: [
    {
      type: 'NativeAppIOS',
      ua: {
        pattern: /([A-Z-]+) ([0-9]+) iphone .*/gi,
        channelCaptureGroupIndex: 1,
        versionCaptureGroupIndex: 2,
      },
      specialFeatures: {
        forceArticleRefetch: false,
        adFree: false,
        disableHeader: false,
        disableConsentModal: false,
        hideSignupAndOrders: {
          enabled: true,
          // Correct channel values: 'DELFI-LT' | 'DELFI-LT-RUS'
          affectedApps: [
            { channel: 'DELFI-LT', version: '719' },
            { channel: 'DELFI-LT-RUS', version: '717' },
          ],
        },
      },
    },
    {
      type: 'NativeAppAndroid',
      ua: {
        pattern: /([A-Z-]+) ([0-9]+) android .*/gi,
        channelCaptureGroupIndex: 1,
        versionCaptureGroupIndex: 2,
      },
      specialFeatures: {
        forceArticleRefetch: false,
        adFree: false,
        disableHeader: false,
        disableConsentModal: false,
        hideSignupAndOrders: {
          enabled: false,
          // Correct channel values: 'DELFI-LT' | 'DELFI-LT-RUS'
          affectedApps: null,
        },
      },
    },
    {
      type: 'LegacyNativeAppIOS',
      ua: {
        pattern: /(DelfiLT)([a-zA-Z]+)\/(\d+).*(ipad|iphone|ipod)/gi,
        channelCaptureGroupIndex: 2,
        versionCaptureGroupIndex: 3,
      },
      signature: false,
      specialFeatures: {
        forceArticleRefetch: true,
        adFree: false,
        disableHeader: false,
        disableConsentModal: false,
        hideSignupAndOrders: {
          enabled: true,
          // Correct channel values: 'www' | 'rudelfi'
          affectedApps: null,
        },
      },
    },
    {
      type: 'LegacyNativeAppAndroid',
      ua: {
        pattern: /(DelfiLT)([a-zA-Z]+)\/(\d+).*(android)/gi,
        channelCaptureGroupIndex: 2,
        versionCaptureGroupIndex: 3,
      },
      signature: false,
      specialFeatures: {
        forceArticleRefetch: false,
        adFree: false,
        disableHeader: false,
        disableConsentModal: false,
        hideSignupAndOrders: {
          enabled: false,
          // Correct channel values: 'www' | 'rudelfi'
          affectedApps: null,
        },
      },
    },
  ],
  searchBotsRegex: 'google|rahvusraamatukogu|cxensebot|bingbot|bingpreview',
  readAccessIps: ['193.40.148.68', '213.219.101.94', '193.40.148.66'],
  adBlockVideosIds: {
    default: {
      adBlock: 'f9b4bf60-a0c0-11ec-a2af-512016e225b7',
      adBlockPlus: 'f9c1dec0-a0c0-11ec-afdb-a9205bbd5cc5',
    },
    ru: {
      adBlock: 'f9b4e670-a0c0-11ec-a2af-512016e225b7',
      adBlockPlus: 'f9c0f460-a0c0-11ec-afdb-a9205bbd5cc5',
    },
  },
  sentryIgnoredCodes: [404],
};

export interface RootConfig {
  main_portal_url: string;
  main_slug: string;
  old_type_redirects: boolean;
  social_share: {
    facebook: string;
    twitter: string;
  };
  player_url: string;
  disableComments: boolean;
  disableLogin: boolean;
  adBlockVideosIds: Record<
    string,
    {
      adBlock: string;
      adBlockPlus: string;
    }
  >;
}
